
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.873 1.873l-.946.94L2.44 4.326A6.607 6.607 0 001.333 8 6.67 6.67 0 008 14.666c1.36 0 2.62-.406 3.673-1.106l1.514 1.513.94-.94L1.873 1.873zM8 13.333A5.34 5.34 0 012.667 8c0-.987.273-1.907.746-2.707l7.294 7.293c-.8.474-1.72.747-2.707.747zm-2.707-9.92l-.966-.973A6.607 6.607 0 018 1.333 6.67 6.67 0 0114.667 8c0 1.36-.407 2.62-1.107 3.673l-.973-.973a5.246 5.246 0 00.746-2.7A5.34 5.34 0 008 2.666c-.987 0-1.907.274-2.707.747z"}})])
          )
        }
      }
    